module.exports = __webpack_public_path__ + "static/media/minus.e06de11d.svg";